import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Dasboard from "./dasboard/dashboard";
import React from 'react';
import clienteAxios from "../axios";
import ModalConfirm from './ModalConfirm';  // Asegúrate de importar el componente ModalConfirm


const Index = () => {
    
    const [preguntas, setPreguntas] = useState([]);
    const [nuevaPregunta, setNuevaPregunta] = useState("");
    const [editandoPreguntaId, setEditandoPreguntaId] = useState(null);
    const [preguntaEditada, setPreguntaEditada] = useState("");
    const [preguntaSeleccionada, setPreguntaSeleccionada] = useState(null);
    const [mensajeExito, setMensajeExito] = useState(false);
    const [opciones, setOpciones] = useState([]);  // Estado para opciones
    const [nuevaOpcion, setNuevaOpcion] = useState("");  // Estado para nueva opción
    const [editandoOpcionId, setEditandoOpcionId] = useState(null);  // Estado para editar opción
    const [opcionEditada, setOpcionEditada] = useState("");  // Texto de la opción editada
    const [opcionSeleccionada, setOpcionSeleccionada] = useState(null);
    const [esPreguntaAbierta, setEsPreguntaAbierta] = useState(false); // Estado para manejar si la pregunta es abierta
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [actionToConfirm, setActionToConfirm] = useState(null);
    const [itemToDelete, setItemToDelete] = useState(null); // Guarda qué ítem será borrado
    const [esOpcionAbiertaEditada, setEsOpcionAbiertaEditada] = useState(false);  // Estado para manejar si la opción es abierta al editar

   
    const inputRef = useRef(null);

 
    // Función para obtener la lista de preguntas
    const obtenerPreguntas = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "preguntas",
                op: "listar"
            });            
            setPreguntas(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    const obtenerOpciones = async (idpregunta) => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "opciones",
                op: "listar",
                idpregunta
            });
            setOpciones(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    // Obtener preguntas al cargar el componente
    useEffect(() => {
        obtenerPreguntas();
    }, []);

    // Función para abrir el modal de confirmación
    const confirmarAccion = (accion, idItem) => {
        setShowConfirmModal(true); // Mostrar el modal
        setActionToConfirm(accion); // Guardar la acción que se va a confirmar
        setItemToDelete(idItem); // Guardar el id del ítem que se quiere borrar
    };

    // Función para cerrar el modal de confirmación
    const cerrarModalConfirmacion = () => {
        setShowConfirmModal(false); // Ocultar el modal
        setActionToConfirm(null); // Limpiar la acción a confirmar
        setItemToDelete(null); // Limpiar el ítem a borrar
    };

    // Función para agregar una nueva pregunta
    const handleAgregarPregunta = async (e) => {
        e.preventDefault();

        if (nuevaPregunta.trim() === "") {
            alert("La pregunta no puede estar vacía.");
            return; // Detener la ejecución si el input está vacío
        }

        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "preguntas",
                op: "nueva",
                pregunta: nuevaPregunta
            });

            setNuevaPregunta(""); // Limpiar el campo
            setMensajeExito(true); // Mostrar el mensaje de éxito
            setTimeout(() => setMensajeExito(false), 3000);
            obtenerPreguntas(); // Actualizar la lista de preguntas
        } catch (error) {
            console.log(error);
        }
    };

    // Función para agregar una nueva opción
    const handleAgregarOpcion = async (e) => {
        e.preventDefault();

        if (nuevaOpcion.trim() === "" || !preguntaSeleccionada) {
            alert("La opción no puede estar vacía.");
            return;
        }

        try {
            await clienteAxios.post("/api/sp", {
                sp: "opciones",
                op: "nueva",
                idpregunta: preguntaSeleccionada,
                texto: nuevaOpcion,
                esAbierta: esPreguntaAbierta ? 1 : 0,
                opcion: "A"  // Aquí puedes ajustar el valor según corresponda
            });

            setNuevaOpcion("");
            obtenerOpciones(preguntaSeleccionada);  // Actualiza la lista de opciones
        } catch (error) {
            console.log(error);
        }
    };


    const togglePreguntaAbierta = () => {
        setEsPreguntaAbierta(!esPreguntaAbierta);
    };

    // Función para editar una pregunta y enfocar el input
    const editarPregunta = (idpregunta, textoActual) => {
        setEditandoPreguntaId(idpregunta);
        setPreguntaEditada(textoActual);
        setPreguntaSeleccionada(idpregunta); // Asegura que los botones aparezcan cuando se selecciona editar
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus(); // Enfoca automáticamente el input
                inputRef.current.setSelectionRange(0, 0); // Coloca el cursor al inicio
            }
        }, 0); // Usamos un pequeño delay para asegurarnos de que el input esté montado
    };

    const guardarPreguntaEditada = async (idpregunta) => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "preguntas",
                op: "actualizar",
                idpregunta: idpregunta,
                pregunta: preguntaEditada
            });

            setEditandoPreguntaId(null); // Finaliza la edición
            setPreguntaSeleccionada(null); // Quitar la selección
            obtenerPreguntas(); // Actualizar la lista de preguntas
        } catch (error) {
            console.log(error);
        }
    };

    // Función para cancelar la edición
    const cancelarEdicion = () => {
        setEditandoPreguntaId(null); // Finaliza la edición
        setPreguntaEditada(""); // Limpiar el campo de edición
        setPreguntaSeleccionada(null); // Ocultar los botones de Guardar y Cancelar
    };

    // Función para borrar una pregunta
    const borrarPregunta = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "preguntas",
                op: "borrar",
                idpregunta: itemToDelete
            });
            obtenerPreguntas(); // Actualizar la lista de preguntas
            cerrarModalConfirmacion(); // Cerrar el modal después de borrar
        } catch (error) {
            console.log(error);
        }
    };

    // Función para seleccionar una pregunta (mostrar botones de Editar y Borrar)
    const seleccionarPregunta = (idpregunta) => {
        setPreguntaSeleccionada(idpregunta === preguntaSeleccionada ? null : idpregunta); // Alternar selección
    };

    // Función para editar una opción
    const guardarOpcionEditada = async (idopcion) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "opciones",
                op: "actualizar",
                idpregunta: preguntaSeleccionada,
                idopcion,
                texto: opcionEditada,
                esAbierta: esOpcionAbiertaEditada ? 1 : 0,  // Enviar si la opción es abierta o no
                opcion: "A"  // Ajusta el valor según corresponda
            });

            setEditandoOpcionId(null);
            obtenerOpciones(preguntaSeleccionada);
        } catch (error) {
            console.log(error);
        }
    };


    // Función para obtener el mensaje del modal de confirmación
    const obtenerMensajeConfirmacion = () => {
        if (actionToConfirm === 'borrarPregunta') {
            return "¿Estás seguro de que quieres borrar esta pregunta?";
        } else if (actionToConfirm === 'borrarOpcion') {
            return "¿Estás seguro de que quieres borrar esta opción?";
        }
        return "¿Estás seguro de que quieres realizar esta acción?";
    };

    // Función para borrar una opción
    const borrarOpcion = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "opciones",
                op: "borrar",
                idpregunta: preguntaSeleccionada,
                idopcion: itemToDelete
            });

            obtenerOpciones(preguntaSeleccionada);  // Actualiza la lista de opciones
            cerrarModalConfirmacion(); // Cerrar el modal después de borrar
        } catch (error) {
            console.log(error);
        }
    };

    const ejecutarAccionConfirmada = () => {
        if (actionToConfirm === 'borrarPregunta') {
            borrarPregunta();
        } else if (actionToConfirm === 'borrarOpcion') {
            borrarOpcion();
        }
    };


    const seleccionarOpcion = (idopcion) => {
        setOpcionSeleccionada(idopcion === opcionSeleccionada ? null : idopcion);
    };

    return (
        <>

            <ModalConfirm
                show={showConfirmModal}
                message={obtenerMensajeConfirmacion()}
                onConfirm={ejecutarAccionConfirmada}
                onCancel={cerrarModalConfirmacion}
            />
             
                <>
                    <Dasboard  />
                    <main className="-mt-32">
                        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                                <div>
                                    <h2 className="text-2xl font-bold mb-6 mt-4">Preguntas</h2>
                                    <ul className="w-full md:w-1/2 ">
                                        {preguntas.map((pregunta) => (
                                            <li
                                                key={pregunta.idpregunta}
                                                className="border p-4 rounded-lg mb-4 cursor-pointer w-full md:w-1/2"
                                                onClick={() => {
                                                    seleccionarPregunta(pregunta.idpregunta);
                                                    obtenerOpciones(pregunta.idpregunta);  // Obtener opciones al seleccionar la pregunta
                                                }}
                                            >
                                                <div className="w-full md:w-1/2 ">
                                                    {/* Aquí mostramos el texto de la pregunta o el input si estamos editando */}
                                                    {editandoPreguntaId === pregunta.idpregunta ? (
                                                        <input
                                                            type="text"
                                                            ref={inputRef}
                                                            value={preguntaEditada}
                                                            onChange={(e) => setPreguntaEditada(e.target.value)}
                                                            className="w-full border rounded-lg p-2 mr-2 "
                                                            style={{
                                                                width: `${Math.min(preguntaEditada.length + 3, 40)}ch`,
                                                                maxWidth: "100%",
                                                                overflow: "hidden",
                                                            }}

                                                        />
                                                    ) : (
                                                        <span>{pregunta.pregunta}</span>
                                                    )}

                                                    {/* Botones de Editar y Borrar en una nueva línea */}
                                                    {(preguntaSeleccionada === pregunta.idpregunta || editandoPreguntaId === pregunta.idpregunta) && (
                                                        <div className="mt-2 w-full md:w-1/2 ">
                                                            {editandoPreguntaId === pregunta.idpregunta ? (
                                                                <>
                                                                    <button
                                                                        onClick={() => guardarPreguntaEditada(pregunta.idpregunta)}
                                                                        className="bg-green-500 text-white rounded px-2 py-1 mr-2 w-full md:w-1/2"
                                                                    >
                                                                        Guardar Pregunta
                                                                    </button>
                                                                    <button
                                                                        onClick={cancelarEdicion}
                                                                        className="bg-gray-700 text-white rounded px-2 py-1 w-full mt-2 md:w-1/2"
                                                                    >
                                                                        Cancelar Edición Pregunta
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <div className="">
                                                                    <div className="space-y-2  md:space-y-0  md:flex ">
                                                                        <button
                                                                            onClick={() => editarPregunta(pregunta.idpregunta, pregunta.pregunta)}
                                                                            className="bg-blue-500 text-white rounded px-2 py-1 mr-2 w-full "
                                                                        >Editar Pregunta</button>
                                                                        <button
                                                                            onClick={() => confirmarAccion('borrarPregunta', pregunta.idpregunta)} // Pasa 'borrarPregunta'
                                                                            className="bg-red-500 text-white rounded px-2 py-1 mr-2 w-full"
                                                                        >Borrar Pregunta</button>
                                                                        <button
                                                                            onClick={cancelarEdicion}
                                                                            className="bg-gray-700 text-white rounded px-2 py-1 w-full"
                                                                        >Cerrar</button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>


                                                {preguntaSeleccionada === pregunta.idpregunta && opciones.length > 0 && (
                                                    <div>
                                                        <h3 className="text-lg font-semibold mt-4">Opciones</h3>
                                                        <ul className="mt-2">
                                                            {opciones.map((opcion) => (
                                                                <li
                                                                    key={opcion.idopcion}
                                                                    className={`border p-2 mb-2 cursor-pointer  ${opcionSeleccionada === opcion.idopcion ? 'bg-gray-200' : ''}`}  // Añadir clase si está seleccionada
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();  // Evitar que el clic en la opción afecte la selección de la pregunta
                                                                        seleccionarOpcion(opcion.idopcion);  // Al hacer clic en la opción, se selecciona
                                                                    }}
                                                                >

                                                                    {editandoOpcionId === opcion.idopcion ? (
                                                                        <div className="space-y-3 md:w-1/2 ">
                                                                            <input
                                                                                type="text"
                                                                                value={opcionEditada}
                                                                                onChange={(e) => setOpcionEditada(e.target.value)}
                                                                                className="border rounded-lg p-2 w-full"
                                                                                style={{
                                                                                    width: `${Math.max(opcionEditada.length + 1, 30)}ch`, // Ajusta el ancho dinámico y establece un tamaño mínimo
                                                                                    minWidth: "20ch", // Asegura que el input no se reduzca demasiado
                                                                                    maxWidth: "100%", // Evita que el input crezca más allá del contenedor
                                                                                    overflow: "hidden", // Esconde cualquier contenido que sobrepase el input

                                                                                }}
                                                                            />


                                                                            <label className="mr-2">Opcion Abierta</label>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={esOpcionAbiertaEditada}
                                                                                onChange={(e) => setEsOpcionAbiertaEditada(e.target.checked)}  // Actualiza el estado del checkbox
                                                                                className="mr-2 "
                                                                            />


                                                                            {/* Botones para guardar o cancelar la edición */}
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation(); // Evitar que el clic afecte la pregunta
                                                                                    guardarOpcionEditada(opcion.idopcion);
                                                                                }}
                                                                                className="ml-2 bg-green-500 text-white rounded px-2 py-1 w-full"
                                                                            >
                                                                                Guardar Opción
                                                                            </button>
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();  // Evitar que el clic afecte la pregunta
                                                                                    setEditandoOpcionId(null);
                                                                                }}
                                                                                className="ml-2 bg-gray-700 text-white rounded px-2 py-1 w-full"
                                                                            >
                                                                                Cancelar Edición Opción
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="space-y-3 md:w-1/2 ">
                                                                            <span>{opcion.texto}</span>
                                                                            {(opcionSeleccionada === opcion.idopcion) && (
                                                                                <>
                                                                                    <div className=" mt-2  space-y-2 w-full md:flex md:space-y-0">
                                                                                        <button
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();  // Evitar que el clic afecte la pregunta
                                                                                                setEditandoOpcionId(opcion.idopcion);
                                                                                                setOpcionEditada(opcion.texto);  // Cargar el texto de la opción al iniciar la edición
                                                                                                setEsOpcionAbiertaEditada(opcion.esAbierta === 1);  // Cargar si la opción es abierta
                                                                                            }}
                                                                                            className="ml-2 bg-blue-500 text-white rounded px-2 py-1 w-full "
                                                                                        >
                                                                                            Editar Opción
                                                                                        </button>

                                                                                        <button
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();  // Evitar que el clic afecte la pregunta
                                                                                                confirmarAccion('borrarOpcion', opcion.idopcion); // Pasa 'borrarOpcion'
                                                                                            }}
                                                                                            className="ml-2 bg-red-500 text-white rounded px-2 py-1 w-full"
                                                                                        >
                                                                                            Borrar Opción
                                                                                        </button>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}


                                                {/* Formulario para agregar nueva opción debajo de las opciones */}

                                                {preguntaSeleccionada === pregunta.idpregunta && (
                                                    <>

                                                        <h2 className=" font-bold mb-6 mt-8">Agregar nueva Opción</h2>
                                                        <form
                                                            onSubmit={(e) => {
                                                                e.stopPropagation();
                                                                handleAgregarOpcion(e);
                                                            }}
                                                            className="space-y-2 md:space-y-0 mt-4 md:flex md:flex-wrap items-center w-full"  // Añadido flex-wrap para permitir la ruptura de línea
                                                            onClick={(e) => e.stopPropagation()}
                                                        >                                                             
                                                            <input
                                                                type="text"
                                                                value={nuevaOpcion}
                                                                onChange={(e) => setNuevaOpcion(e.target.value)}
                                                                placeholder="Nueva opción"
                                                                className="border rounded-lg p-2 mr-2"
                                                                style={{
                                                                    width: `${Math.max(nuevaOpcion.length + 1, 30)}ch`,
                                                                    minWidth: "20ch",
                                                                    maxWidth: "100%",
                                                                    overflow: "hidden",
                                                                }}
                                                            />                                                            
                                                            <div className="flex items-center mr-4">
                                                                <label className="mr-2">Opción Abierta</label>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={esPreguntaAbierta}
                                                                    onChange={() => setEsPreguntaAbierta(!esPreguntaAbierta)}
                                                                    className="toggle-switch"
                                                                />
                                                            </div>                                                           
                                                            <button
                                                                type="submit"
                                                                className="bg-green-500 text-white rounded px-2 py-1 mt-2 "
                                                            >
                                                                Agregar Opción
                                                            </button>
                                                        </form>

                                                    </>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="w-full md:w-1/2">
                                    <h2 className=" font-bold mb-6 mt-8">Agregar nueva pregunta</h2>
                                    <form onSubmit={handleAgregarPregunta} className="w-full md:w-1/2">
                                        <input
                                            type="text"
                                            value={nuevaPregunta}
                                            onChange={(e) => setNuevaPregunta(e.target.value)}
                                            placeholder="Nueva pregunta"
                                            className="border rounded-lg p-2 mr-2 w-full"
                                            style={{
                                                width: `${Math.max(nuevaPregunta.length + 1, 60)}ch`, // Ajusta el ancho dinámico y establece un tamaño mínimo
                                                minWidth: "20ch", // Asegura que el input no se reduzca demasiado
                                                maxWidth: "100%", // Evita que el input crezca más allá del contenedor
                                                overflow: "hidden", // Esconde cualquier contenido que sobrepase el input
                                            }}
                                        />
                                        <button type="submit" className="bg-blue-500 rounded text-white px-2 py-1 w-full mt-2 md:w-1/2">
                                            Agregar Pregunta Nueva
                                        </button>
                                    </form>
                                    {mensajeExito && (
                                        <p className="text-green-600 mt-2">Pregunta agregada exitosamente</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </main>
                </>            
        </>
    );


};

export default Index;
